import React, { useEffect, useMemo, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik, yupToFormErrors } from "formik"
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr from "toastr"
import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "../../store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import axios from "../../axios"
import Select from "react-select"
import numeral from "numeral"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  Table,
  Button,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { makeStyles } from "@material-ui/core/styles"
import DeleteModal from "../../components/Common/DeleteModal"
import SweetAlert from "react-bootstrap-sweetalert"
import Switch from "react-switch"
import { Dialog, DialogTitle } from "@material-ui/core"
import Backdrop from "@material-ui/core/Backdrop"
import Spinner from "react-spinkit"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}))
function DatatableTables() {
  const [modal, setModal] = useState(false)
  // const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const classes = useStyles()
  const [userList, setUserList] = useState([])
  const [user, setUser] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)
  const [coutrysuccess, setcoutrysuccess] = useState(false)
  const [countryerror, setcountryerror] = useState(false)
  const [countryinfo, setcountryinfo] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [switch1, setswitch1] = useState(true)
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [allqaparameter, setallqaparameter] = useState([])
  const [allcategorycollections, setallcategorycollections] = useState([])
  const [allproductscollection, setallproductscollection] = useState([])
  const [categrid, setcategrid] = useState("")
  const [allpriuomcollection, setallpriuomcollection] = useState([])
  const [priuomid, setpriuomid] = useState("")
  const [allsecondaryuomcollection, setallsecondaryuomcollection] = useState([])
  const [secuomid, setsecuomid] = useState("")
  const [allbrandcollections, setallbrandcollections] = useState([])
  const [brandid, setbrandid] = useState("")
  const [alltaxcollections, setalltaxcollections] = useState([])
  const [taxid, settaxid] = useState("")
  const [hsncode, sethsncode] = useState("")
  const [categoryfilter, setcategoryfilter] = useState([])
  const categoryref = useRef("")
  const priuomref = useRef("")
  const secondaryuomref = useRef("")
  const brandref = useRef("")
  const vatref = useRef("")
  const [open, setopen] = useState(false)
  const [categorydefaultvalue, setcategorydefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [priuomdefaultvalue, setpriuomdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [secondaryuomdefaultvalue, setsecondaryuomdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [branddefaultvalue, setbranddefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [vatpercentagedefaultvalue, setvatpercentagedefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [proid, setproid] = useState("")
  const [gsterror, setgsterror] = useState(false)
  const [categoryerror, setcategoryerror] = useState(false)
  const [secondaryuomerror, setsecondaryuomerror] = useState(false)
  const [priuomderror, setpriuomderror] = useState(false)
  const [buyerattcheload, setbuyerattcheload] = useState({ Imagepath: "" })
  const [buyerattchenamte, setbuyerattchenamte] = useState("")
  const [buyerattch, setbuyerattch] = useState(null)
  const [branderror, setbranderror] = useState(false)
  const [Poupuimage, setPoupuimage] = useState("")
  const [dialogbox, setdialogbox] = useState(false)
  const [productvalue, setproductvalue] = useState("")
  const [ratecodevalue, setratecodevalue] = useState("")
  const [cusid, setcusid] = useState("")
  const [alltransportcollections, setalltransportcollections] = useState([])
  const [customererrors, setcustomererrors] = useState(false)
  const [customerdefaultvalue, setcustomerdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [stateid, setstateid] = useState("")
  const [statedefaultvalue, setstatedefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [onestatecolletions, setonestatecolletions] = useState([])
  const [editidcate, seteditidcate] = useState("")
  const [allproductslists, setallproductslists] = useState({
    Category_Id: "",
    Category_Code: "",
    Category_Description: "",
    Created_By: "",
    Created_Date: "",
    Modify_By: "",
    Modify_Date: "",
    Active: true,
    MainCategory_Id: "",
  })

  const PhoneRegExps = /^[0-9 () +-]+$/
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: allproductslists,

    validationSchema: Yup.object({
      Category_Description: Yup.string().required("Please Enter Sub category"),
      Category_Code: Yup.string().matches(
        PhoneRegExps,
        "Please Enter a vaild Category Code"
      ),
    }),
    onSubmit: async values => {
      if (isEdit) {
        const update = await axios.instance
          .put(
            `/updatesubcategory/${proid}`,
            {
              Category_Code: values.Category_Code,
              Category_Description: values.Category_Description,
              Modify_By: localStorage.getItem("UserId"),
              Modify_Date: new Date(),
              Active: values.Active ? "Y" : "N",
              MainCategory_Id: cusid,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            // update user
            if (res.data === "") {
              GetallTransport()
              toggle()
              setcountryinfo(true)

              validation.resetForm()
            } else {
              setduplicateerro(true)
            }
          })
      } else {
        if (cusid.length != 0) {
          const createoneuser = await axios.instance
            .post(
              "/Insertsubcategory",
              {
                Category_Description: values.Category_Description,
                Category_Code: values.Category_Code,
                Created_By: localStorage.getItem("UserId"),
                Created_Date: new Date(),
                Active: values.Active ? "Y" : "N",
                MainCategory_Id: cusid,
              },
              {
                headers: {
                  Authorization: tokent,
                  "Content-Type": "application/json",
                },
              }
            )
            .then(res => {
              //console.log(res.data)

              if (res.data.length === 1) {
                setcoutrysuccess(true)

                //console.log(res.data)
                GetallTransport()
                validation.resetForm()
                toggle()
              } else {
                setduplicateerro(true)
              }
              //toastr.success('Garment Description Added Successfully', 'Garment')
            })
        } else {
          if (cusid.length === 0) {
            setcustomererrors(true)
          }
          setTimeout(() => {
            setcustomererrors(false)
          }, 2000)
        }
      }

      setDeleteModal(false)
    },
  })
  // const toggleViewModal = () => setModal1(!modal1);

  const toggle = () => {
    if (modal) {
      setModal(false)

      setUser(null)
      validation.resetForm()
      setallproductslists({
        Category_Code: "",
        Category_Description: "",
        Created_By: "",
        Created_Date: "",
        Modify_By: "",
        Modify_Date: "",
        Active: true,
      })

      setcustomerdefaultvalue({ label: "Select...", value: "" })
    } else {
      setModal(true)
    }
  }

  const handleUserClick = async arg => {
    //console.log(arg)

    const qapara = arg
    console.log("t", arg)
    setproid(qapara.Category_Id)
    setcusid(qapara.MainCategory_Id)
    //console.log
    setallproductslists({
      Category_Code: qapara.Category_Code,
      Category_Description: qapara.Category_Description,
      MainCategory_Id: qapara.MainCategory_Id,
      Active: qapara.Active === "Y",
    })

    const deleteoneuser = await axios.instance
      .get(`/Getonemaincategory/${qapara.MainCategory_Id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        console.log(res.data)
        for (const data of res.data) {
          setcustomerdefaultvalue({
            label: qapara.MainCategory_Description,
            value: qapara.MainCategory_Id,
          })

          setcusid(data.MainCategory_Id)
        }
      })

    setIsEdit(true)

    toggle()
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)
  const [allsupplierinfo, setallsupplierinfo] = useState([])
  const [allstates, setallstates] = useState([])
  const [satenme, setsatenme] = useState("")
  const [statecode, setstatecode] = useState("")
  const onClickDelete = user => {
    setdeletid(user.Category_Id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (user.id) {
      dispatch(onDeleteUser(user))
      setDeleteModal(false)
    }
  }
  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }
  useEffect(() => {
    GetallTransport()
    Getallsuppliervalue()
  }, [])

  const Countrydelete = async () => {
    const deleteoneuser = await axios.instance
      .delete(`/Deletesubcategory/${deletid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data === "") {
          ////console.log(res.data)
          GetallTransport()
          setDeleteModal(false)
          //toastr.error ('User Deleted Successfully', 'User')
          setcountryerror(true)
        } else {
          toastr.error(
            "Item is associated with existing records.",
            "Unable to delete"
          )
          setDeleteModal(false)
        }
      })
  }

  const getcustomid = id => {
    setcusid(id)
  }

  const Closepopup = () => {
    setopen(false)
  }

  const Getallsuppliervalue = async () => {
    const get = await axios.instance
      .get(`/Getallmaincatogry`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.MainCategory_Description,
          value: b.MainCategory_Id,
        }))

        setallsupplierinfo(options)
      })
  }

  const GetallTransport = async () => {
    const get = await axios.instance
      .get("/Getallsubcategory", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setalltransportcollections(res.data)
      })
  }

  const columns = useMemo(
    () => [
      {
        Header: "Category Description ",
        accessor: "Category_Description",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Active",
        accessor: "Active",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const users = cellProps.row.original
                      onClickDelete(users)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={Countrydelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master" breadcrumbItem="Sub Category Master" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={alltransportcollections}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Sub-Category" : "Add Sub-Category"}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="12">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>Maincategory </b>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allsupplierinfo}
                      //ref={categoryref}
                      classNamePrefix="select2-search-disable"
                      onChange={value => getcustomid(value.value)}
                      defaultValue={customerdefaultvalue}
                    />
                    {customererrors ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Customer{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>Category Code </b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="Category_Code"
                      className="form-control"
                      id="basicpill-card-verification-input"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Category_Code || ""}
                      invalid={
                        validation.touched.Category_Code &&
                        validation.errors.Category_Code
                          ? true
                          : false
                      }
                    />
                    {/* {validation.touched.Category_Code && validation.errors.Category_Code ? (
                     <FormFeedback type="invalid">{validation.errors.Category_Code}</FormFeedback>
                   ) : null} */}
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>Subcategory </b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="Category_Description"
                      className="form-control"
                      id="basicpill-card-verification-input"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Category_Description || ""}
                      invalid={
                        validation.touched.Category_Description &&
                        validation.errors.Category_Description
                          ? true
                          : false
                      }
                    />
                    {validation.touched.Category_Description &&
                    validation.errors.Category_Description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.Category_Description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mt-4 mt-md-0">
                    <div className="vstack gap-2">
                      <div className="form-check form-switch form-switch-lg">
                        <Label
                          className="form-check-label"
                          htmlFor="activeSwitch"
                        >
                          Active
                        </Label>
                        <input
                          name="Active"
                          type="checkbox"
                          className="form-check-input"
                          id="activeSwitch"
                          checked={validation.values.Active}
                          onClick={() => {
                            const newActiveState = !validation.values.Active
                            console.log(
                              "Toggling Active state to:",
                              newActiveState
                            )
                            validation.setFieldValue("Active", newActiveState)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <div className="text-end">
                  {!!isEdit ? (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Add
                    </button>
                  )}
                </div>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>
      {duplicateerro ? (
        <SweetAlert
          title="Sub Category  Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}

      {coutrysuccess ? (
        <SweetAlert
          title="Sub Category Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcoutrysuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryinfo ? (
        <SweetAlert
          title="Sub Category Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryerror ? (
        <SweetAlert
          title="Sub Category Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryerror(false)
          }}
        ></SweetAlert>
      ) : null}

      <Backdrop open={dialogbox} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>
      <Dialog
        onClose={Closepopup}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <img src={Poupuimage} style={{ width: "500px", height: "500px" }} />
      </Dialog>
    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
